import React from "react";

import { Divider, Skeleton } from "antd";
import { Container } from "react-bootstrap";

const CompanyDetailLoading = () => {
  return (
    <Container>
      <div
        style={{
          border: "1px solid #e6e6e6",
          boxSizing: "border-box",
          borderRadius: "8px",
          padding: "30px",
          marginBottom: "30px",
          marginTop: "30px",
        }}
      >
        <Skeleton.Button
          active
          size="default"
          style={{
            width: "1200px",
            height: "200px",
            borderRadius: 5,
          }}
        />
        <div style={{ display: "flex" }}>
          <Skeleton.Image
            active
            style={{
              width: "150px",
              height: "150px",
              borderRadius: 5,
              marginTop: "25px",
            }}
          />
          <Skeleton
            active
            style={{
              width: "280px",
              height: "180px",
              borderRadius: 5,
              marginTop: "25px",
              marginLeft: "25px",
            }}
          />
        </div>
        <Skeleton.Button
          active
          style={{
            width: "700px",
            height: "65px",
            borderRadius: 5,
            marginTop: "25px",
          }}
        />
        <Divider />
        <Skeleton
          active
          paragraph={{ rows: 1 }}
          style={{
            width: "1210px",
            height: "65px",
            borderRadius: 5,
            marginTop: "25px",
          }}
        />
        <Divider />
        <Skeleton.Button
          active
          style={{
            width: "200px",
            height: "50px",
            borderRadius: 5,
            marginTop: "25px",
          }}
        />
        <Skeleton
          active
          paragraph={{ rows: 5 }}
          style={{
            width: "1210px",
            height: "65px",
            borderRadius: 5,
            marginTop: "25px",
          }}
        />
      </div>
    </Container>
  );
};

export default CompanyDetailLoading;
